import { useNavigate } from "react-router-dom";
import { useSnapshot } from "valtio";
import type { BannerEditorRouterState } from "@/modules/banners/bannerForm";
import { bannerPreviewStore } from "./bannerPreviewStore";
import BannerPreviewBar from "./BannerPreviewBar";
import "./dashboardBanner.scss";

/** The ADMIN PREVIEW bar, rendered by the app shell while a banner preview is on screen (MPN-2266). */
export default function BannerPreviewShellBar() {
    const { preview } = useSnapshot(bannerPreviewStore);
    const navigate = useNavigate();
    if (!preview) return null;

    const { bannerPreview, bannerId, returnTo } = preview;
    const backToEditor = () => {
        const state: BannerEditorRouterState = { bannerDraft: { ...bannerPreview }, bannerId };
        navigate(returnTo, { replace: true, state });
    };
    return <BannerPreviewBar onBack={backToEditor} />;
}
